import React from 'react';
import PropTypes from 'prop-types';
import Form from '../form/Form';
import { modal } from '../modal/ModalEmitter';
import ApiService from '../../services/ApiService';

const getLayout = (quoteOptions, activeItemId = '') => {
  const options =
    !quoteOptions.length && activeItemId ? [{ label: `Quote ${activeItemId}`, value: activeItemId }] : quoteOptions;

  return [
    {
      label: 'Quote',
      name: 'itemId',
      options,
      required: true,
      data: activeItemId,
    },
    {
      label: 'Title',
      name: 'title',
      col: 12,
      placeholder: 'Brief Title',
    },
    {
      label: 'Public',
      name: 'isPublic',
      control: 'Checkbox',
      col: 2,
      data: 'Y',
      hidden: true,
    },
    {
      label: '',
      name: 'noteBody',
      control: 'Markdown',
      required: true,
    },
  ];
};

const AddNote = ({
  itemId = '',
  listId = 'EQS1',
  onCancel = () => modal.close(),
  options = [],
  submitCallback = () => modal.close(),
}) => {
  const handleSubmit = payload => {
    payload.listId = listId;

    return ApiService.post('/note', payload).then(() => {
      if (submitCallback) submitCallback();
    });
  };

  return (
    <Form
      exportFormat="object"
      layout={getLayout(options, itemId)}
      onCancel={onCancel}
      showHelp={false}
      submit={handleSubmit}
      submitAll
      trackDirty={false}
    />
  );
};

AddNote.propTypes = {
  listId: PropTypes.string,
  submitCallback: PropTypes.func,
};

export default AddNote;
